export const iconFontAwesomeFilmVideoVideoSlash = (
	<i className="fa-solid fa-video-slash"></i>
);
